export default "__VITE_ASSET__B3Yclcwx__"